enum DefaultPermissionLevel {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  COUNTRY_LEVEL = 'COUNTRY_LEVEL',
  PROJECT_LEVEL = 'PROJECT_LEVEL',
  LIMITED_ACCESS = 'LIMITED_ACCESS',
  NATIONAL_LEVEL = 'NATIONAL_LEVEL',
}

export default DefaultPermissionLevel;
